export default __webpack_public_path__ + "static/media/google.c05c3879.png";